import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import './admin.css';
import { AdminAuthProvider, useAdminAuth } from './AdminAuth';
import AdminHome from './AdminHome';
import AdminLayout from './AdminLayout';
import AdminLogin from './AdminLogin';
import AdminSection from './AdminSection';

const AdminRoutes: React.FC = () => {
  const { session, ready } = useAdminAuth();

  if (!ready) {
    return (
      <div className="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-text-sm tw-text-muted-foreground">
        Checking sign-in...
      </div>
    );
  }

  if (!session) {
    return (
      <Routes>
        <Route index element={<AdminLogin />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<AdminHome />} />
        <Route path="photos" element={<AdminSection section="photos" />} />
        <Route path="carousel" element={<AdminSection section="carousel" />} />
        <Route path="content" element={<AdminSection section="content" />} />
        <Route path="messages" element={<AdminSection section="messages" />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
    </Routes>
  );
};

const AdminApp: React.FC = () => {
  return (
    <div id="admin">
      <AdminAuthProvider>
        <AdminRoutes />
      </AdminAuthProvider>
    </div>
  );
};

export default AdminApp;
